import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick"]

import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewComment',
  props: {
  comment: {
    type: String,
    required: true
  },
  maxLength: {
    type: Number,
    required: true
  }
},
  setup(__props) {

const props = __props;



const isCommentExpanded = ref(false);

const isFullCommentVisible = computed(() => {
  return isCommentExpanded.value || props.comment.length <= props.maxLength;
});

const truncatedComment = computed(() => {
  return props.comment.slice(0, props.maxLength);
});

const expandComment = () => {
  isCommentExpanded.value = true;
};

return (_ctx: any,_cache: any) => {
  return (isFullCommentVisible.value)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createTextVNode(_toDisplayString(props.comment), 1)
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createTextVNode(_toDisplayString(truncatedComment.value) + "\n    ...\n    ", 1),
        _createElementVNode("a", {
          href: "#",
          onClick: _withModifiers(expandComment, ["prevent"]),
          class: "text-blue"
        }, "\n      もっと見る\n    ", 8, _hoisted_1)
      ], 64))
}
}

})